import { Injectable } from '@angular/core';
import { IAuthModuleConfig } from '@web/dtos';

export interface AppConfig {
  version: string;
  stage: string;
  client: {
    name: string;
    id: string;
  };
  general: {
    cmsUrl: string;
    /** .NET server base URL, without the /api route prefix. */
    webshopApiUrl: string;
    addressValidationUrl: string;
    authenticatedUrl: string;
    contractUrl: string;
    efaUrl: string;
    entitlementUrl: string;
    paymentUrl: string;
    directTicketUrl: string;
    tariffUrl: string;
    userServiceUrl: string;
    notifyTemplateUrl: string;
    stage: string;
  };
  auth: IAuthModuleConfig;
}

@Injectable({
  providedIn: 'root',
})
export class AppConfigService {
  private config!: AppConfig;

  load(config: AppConfig) {
    this.config = config;
  }

  get(): AppConfig {
    return this.config;
  }
}
